import HealthcareClinicPoi from '@/assets/smartcity/healthcare-clinic-poi.svg';
import HealthcareHospitalPoi from '@/assets/smartcity/healthcare-hospital-poi.svg';
import HealthcareOtherPoi from '@/assets/smartcity/healthcare-other-poi.svg';
import HealthcarePhcPoi from '@/assets/smartcity/healthcare-phc-poi.svg';

// Healthcare POI icon + legend label per facility type. Keyed on the raw
// cm_code (map/poi's health_facility.type.code) rather than its label, which
// arrives in the session language.
export interface HealthcarePoiType {
  code: string;
  icon: string;
  // cm_language tag; defaultLabel is what shows until the tag is seeded.
  labelTag: string;
  defaultLabel: string;
}

// Order = legend order.
export const HEALTHCARE_POI_TYPES: HealthcarePoiType[] = [
  {
    code: 'HLTH_FAC_TP_HSP',
    icon: HealthcareHospitalPoi,
    labelTag: 'psc>map>hospital',
    defaultLabel: 'Hospital (RS)',
  },
  {
    code: 'HLTH_FAC_TP_PHC',
    icon: HealthcarePhcPoi,
    labelTag: 'psc>map>public health center',
    defaultLabel: 'Public Health Center',
  },
  {
    code: 'HLTH_FAC_TP_CLN',
    icon: HealthcareClinicPoi,
    labelTag: 'psc>map>clinic',
    defaultLabel: 'Clinic',
  },
  {
    code: 'HLTH_FAC_TP_OTH',
    icon: HealthcareOtherPoi,
    labelTag: 'psc>map>other',
    defaultLabel: 'Other',
  },
];

const ICON_BY_CODE = new Map(HEALTHCARE_POI_TYPES.map((type) => [type.code, type.icon]));

// A facility with no type (or one added to cm_code later) is drawn as "Other",
// so every healthcare POI still gets one of the four legend icons.
export const getHealthcarePoiIcon = (code?: string | null): string =>
  (code ? ICON_BY_CODE.get(code) : undefined) ?? HealthcareOtherPoi;
